export default __webpack_public_path__ + "static/media/Mars-in-Leo-1.f2d3fdd0.jpg";